import Swal from 'sweetalert2';

/**
 * Servicio de alertas que encapsula SweetAlert2
 * Si en el futuro se desea cambiar la biblioteca de alertas,
 * solo será necesario modificar este archivo
 */
export const AlertService = {
  /**
   * Muestra una alerta de éxito
   * @param {string} message - Mensaje a mostrar
   * @param {string} title - Título de la alerta (opcional)
   * @param {Object} options - Opciones adicionales para personalizar la alerta
   */
  success(message, title = 'Éxito', options = {}) {
    return Swal.fire({
      title,
      text: message,
      icon: 'success',
      confirmButtonText: 'Aceptar',
      ...options
    });
  },

  /**
   * Muestra una alerta de error
   * @param {string} message - Mensaje a mostrar
   * @param {string} title - Título de la alerta (opcional)
   * @param {Object} options - Opciones adicionales para personalizar la alerta
   */
  error(message, title = 'Error', options = {}) {
    return Swal.fire({
      title,
      text: message,
      icon: 'error',
      confirmButtonText: 'Aceptar',
      ...options
    });
  },

  /**
   * Muestra una alerta de información
   * @param {string} message - Mensaje a mostrar
   * @param {string} title - Título de la alerta (opcional)
   * @param {Object} options - Opciones adicionales para personalizar la alerta
   */
  info(message, title = 'Información', options = {}) {
    return Swal.fire({
      title,
      text: message,
      icon: 'info',
      confirmButtonText: 'Aceptar',
      ...options
    });
  },

  /**
   * Muestra una alerta de advertencia
   * @param {string} message - Mensaje a mostrar
   * @param {string} title - Título de la alerta (opcional)
   * @param {Object} options - Opciones adicionales para personalizar la alerta
   */
  warning(message, title = 'Advertencia', options = {}) {
    return Swal.fire({
      title,
      text: message,
      icon: 'warning',
      confirmButtonText: 'Aceptar',
      ...options
    });
  },

  /**
   * Muestra un diálogo de confirmación
   * @param {string} message - Mensaje a mostrar
   * @param {string} title - Título del diálogo (opcional)
   * @param {Object} options - Opciones adicionales para personalizar el diálogo
   * @returns {Promise} - Promesa que se resuelve con el resultado del diálogo
   */
  confirm(message, title = '¿Está seguro?', options = {}) {
    return Swal.fire({
      title,
      text: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      ...options
    });
  },

  /**
   * Muestra una alerta personalizada
   * @param {Object} options - Opciones para personalizar la alerta
   * @returns {Promise} - Promesa que se resuelve con el resultado de la alerta
   */
  custom(options = {}) {
    return Swal.fire(options);
  },

  /**
   * Cierra todas las alertas abiertas
   */
  close() {
    Swal.close();
  }
};

export default AlertService;
